import { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useI18n } from '../lib/i18n';
import { useRedeemAccessLink } from '../lib/queries';
import { Button, Logo, Spinner } from '../components/ui';

export function AccessPage() {
  const { token } = useParams<{ token: string }>();
  const { t } = useI18n();
  const navigate = useNavigate();
  const redeem = useRedeemAccessLink();

  // The grant is single use, so redeeming must happen exactly once per token
  // however many times this effect runs — StrictMode deliberately runs it
  // twice in development, and a remount would otherwise burn the link.
  const redeemedToken = useRef<string | null>(null);

  useEffect(() => {
    if (!token || redeemedToken.current === token) return;
    redeemedToken.current = token;
    // Replaces the entry so the spent link is not left in history.
    redeem.mutate(token, { onSuccess: () => navigate('/', { replace: true }) });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <main className="mx-auto flex min-h-dvh w-full max-w-sm flex-col items-center justify-center gap-6 px-6 text-center">
      <Logo size="lg" />
      {(redeem.isPending || redeem.isSuccess) && (
        <>
          <Spinner />
          <p className="text-sm text-ink-dim">{t('login.linkWorking')}</p>
        </>
      )}
      {redeem.isError && (
        <>
          <p className="text-[0.95rem] leading-relaxed text-ink-dim">{t('login.linkInvalid')}</p>
          <Button variant="ghost" onClick={() => { window.location.href = '/'; }}>
            {t('login.title')}
          </Button>
        </>
      )}
    </main>
  );
}
